import React from "react";
import styles from "./Button.module.scss"
import {Link} from 'react-router-dom';

export default function Button ({text, url, target = '_blank', external = false, children}) {
    return (
        external ?
            <a href={url} {...{target}} className={styles.Main}>
                <span>{text}</span>
                {children}
            </a>
            :
            <Link to={url} className={styles.Bordered}>
                <span>{text}</span>
                {children}
            </Link>
    )
}
